
import { Component, Vue, Prop } from 'vue-property-decorator'

import { TextFieldRules, DefaultCardList } from '@/utils/enums'
import { CardList } from '@/types/Card'
import cardModule from '@/store/card'
import authModule from '@/store/auth'
import whitelabelModule from '@/store/whitelabel'
import { compareNested } from '@/utils/utility-manager'

@Component({
  name: 'CardListEditor'
})
class CardListEditor extends Vue {
  @Prop() readonly edit?: boolean
  private rules = TextFieldRules
  private form: Partial<CardList> = {
    name: '',
    subtitle: '',
    index: 0,
    cards: [''],
    interval: null,
    shuffled: false
  }

  private get cardList() {
    return cardModule.cardList!
  }

  private get auth() {
    return authModule
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get whitelabels() {
    return whitelabelModule.whitelabels
  }

  private get cards() {
    return cardModule.cards
  }

  private get isFeatured() {
    return this.form.name === DefaultCardList.NAME
  }

  private async created(): Promise<void> {
    cardModule.fetchAll({ limit: 0, lean: true })

    if (!this.edit) return
    if (!this.cardList) {
      await cardModule.fetch(this.$route.params.cid)
    }

    this.form = JSON.parse(JSON.stringify(this.cardList))
  }

  private addCard(): void {
    this.form.cards!.push('')
  }

  private removeCard(index: number): void {
    this.form.cards!.splice(index, 1)
  }

  private async saveCardList(): Promise<void> {
    if (!this.edit) {
      cardModule.createCardList({
        whitelabel: this.whitelabel._id,
        cardList: this.form
      })
    } else {
      const payload: Partial<CardList> = await compareNested(
        this.form,
        this.cardList
      )
      Object.assign(payload, { _id: this.cardList!._id })
      cardModule.updateCardList({
        whitelabel: this.cardList.whitelabel,
        cardList: payload
      })
    }
    document.dispatchEvent(new Event('close-cardList'))
  }
}

export default CardListEditor
